import React from 'react';
import Config from '../../../../../Config';
import { iconNoCustomer } from '../../images';
import './noCustomerDomainsPage.scss';

type CmsLinkRef = {
  expandedValue?: { url?: string };
  value?: string | { url?: string };
};

type Props = {
  link?: CmsLinkRef;
};

const pageUrl = (pageRef: CmsLinkRef | undefined): string | null => {
  if (!pageRef) {
    return null;
  }
  const raw =
    pageRef.expandedValue?.url ||
    (typeof pageRef.value === 'object' ? pageRef.value?.url : pageRef.value);
  if (!raw || typeof raw !== 'string') {
    return null;
  }
  if (raw.startsWith('http') || raw.startsWith('/')) {
    return raw;
  }
  return Config.epiBaseUrl + raw;
};

const NoCustomerDomainsPage: React.FunctionComponent<Props> = ({ link }) => {
  const href = pageUrl(link);

  const handleClick = () => {
    if (!href) {
      return;
    }
    window.location.href = href;
  };

  return (
    <div className="problem-domain-no-customer-domains" role="status">
      <div className="problem-domain-no-customer-domains__content">
        <img src={iconNoCustomer} alt="" className="problem-domain-no-customer-domains__icon" />
        <h2 className="problem-domain-no-customer-domains__title">
          לא מצאנו שירות
          <br />
          שבו יכולה להיות לך תקלה
        </h2>
      </div>
      <div className="problem-domain-no-customer-domains__footer">
        <button
          type="button"
          className="problem-domain-no-customer-domains__button"
          onClick={handleClick}
          disabled={!href}
        >
          למגוון הפעולות
        </button>
      </div>
    </div>
  );
};

export default NoCustomerDomainsPage;
